import { render } from "./back.vue?vue&type=template&id=0565b0a1&ts=true"
import script from "./back.vue?vue&type=script&lang=ts"
export * from "./back.vue?vue&type=script&lang=ts"

import exportComponent from "/home/webchat/thelounge-lfnet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__